import React from 'react'
import useLocalStorage from './useLocalStorage'

function isActiveEvent({ startDate, endDate }) {
  if (endDate) {
    return new Date(endDate).getTime() > new Date().getTime()
  }

  return new Date(startDate).getTime() > new Date().getTime()
}

function useLogRecentlyVisitedEvents(event) {
  const [recentlyVisitedEvents, setRecentlyVisitedEvents] = useLocalStorage(
    'recently_visited_events',
    []
  )
  const activeEvents = recentlyVisitedEvents.filter(isActiveEvent)

  React.useEffect(() => {
    if (activeEvents.length !== recentlyVisitedEvents.length) {
      setRecentlyVisitedEvents(activeEvents)
    }
  }, [activeEvents, recentlyVisitedEvents, setRecentlyVisitedEvents])

  React.useEffect(() => {
    if (event && isActiveEvent(event)) {
      const recentlyVisitedEventsContainsCurrentEvent =
        activeEvents.filter(({ id }) => id === event.id).length > 0

      // Save event-data to `recentlyVisited` in localStorage if it’s not
      // in there yet. Will be displayed in SiteSearch.
      if (!recentlyVisitedEventsContainsCurrentEvent) {
        setRecentlyVisitedEvents([
          {
            // Store only the data we need.
            __typename: 'EventResult',
            id: event.id,
            name: event.name,
            slug: event.slug,
            startDate: event.startDate,
            endDate: event?.endDate,
            locationName: event?.location?.name,
            cityName: event?.location?.city?.name,
            country: event?.location?.country,
          },
          // Store no more than 5 items.
          ...activeEvents.slice(0, 4),
        ])
      }
    }
  }, [event, activeEvents, setRecentlyVisitedEvents])

  return [activeEvents, setRecentlyVisitedEvents]
}

export default useLogRecentlyVisitedEvents
